module.exports = __webpack_public_path__ + "static/img/ewm.5eef4950.png";